import { BookingCompressed } from '@jooxter/api';

export const isBookingValidated = (booking: BookingCompressed) => {
  if (booking?.resource.requestOwnerValidation) {
    if (!booking.rejected && !booking.approved && !booking.cancelled && !booking.checkout) {
      return false;
    }
  }
  return true;
};

export const displayOwnerValidationStatus = (booking: BookingCompressed): boolean | undefined => {
  if (booking?.resource.requestOwnerValidation) {
    return isBookingValidated(booking);
  }
};

export const displayOwnerValidationWaiting = (booking: BookingCompressed): boolean => {
  if (booking?.resource.requestOwnerValidation) {
    if (!booking.rejected && !booking.approved && !booking.cancelled && !booking.checkout) {
      return true;
    }
  }
  return false;
};
